/** What an event of the staff stream makes stale on the specialists screens. */
import { textOf, type LiveEvent, type Refresh } from "@/shared/live";

import { specialistKey, SPECIALISTS_KEY, specialistVisitsKey } from "./queries";

/** Presence flickers as people come and go: the list waits a little longer for the rest. */
const PRESENCE_DELAY_MS = 1_000;

/** Events after which a specialist holds another set of visits, or one of them reads differently. */
const MOVES_A_VISIT: ReadonlySet<string> = new Set([
  "visit.status_changed",
  "visit.assigned",
  "visit.released",
  "visit.cancelled",
  "visit.completed",
  "visit.lines_changed",
]);

export function specialistsLive(event: LiveEvent, refresh: Refresh): void {
  switch (event.type) {
    case "specialist.created":
    case "specialist.status_changed": {
      // The lists, the counts on their tabs, the sidebar's number.
      refresh([...SPECIALISTS_KEY, "list"]);
      refresh([...SPECIALISTS_KEY, "counts"]);
      const userId = textOf(event, "user_id");
      if (userId !== null) refresh(specialistKey(userId));
      return;
    }
    case "specialist.presence_changed": {
      refresh([...SPECIALISTS_KEY, "list"], PRESENCE_DELAY_MS);
      // The counts can be narrowed to who is at work.
      refresh([...SPECIALISTS_KEY, "counts"], PRESENCE_DELAY_MS);
      const userId = textOf(event, "user_id");
      if (userId !== null) refresh(specialistKey(userId), PRESENCE_DELAY_MS);
      return;
    }
    case "visit.rated":
    case "visit.rating_moderated": {
      const specialistId = textOf(event, "specialist_id");
      if (specialistId === null) return;
      refresh([...SPECIALISTS_KEY, "rating", specialistId]);
      refresh([...SPECIALISTS_KEY, "ratings", specialistId]);
      // A row carries the average, and a visit its score.
      refresh([...SPECIALISTS_KEY, "list"], PRESENCE_DELAY_MS);
      refresh(specialistVisitsKey(specialistId));
      return;
    }
    default:
  }
  if (MOVES_A_VISIT.has(event.type)) {
    const specialistId = textOf(event, "specialist_id");
    if (specialistId === null) return;
    // Their visits, and how many they hold now: on their page and on their row.
    refresh(specialistVisitsKey(specialistId));
    refresh(specialistKey(specialistId));
    refresh([...SPECIALISTS_KEY, "list"], PRESENCE_DELAY_MS);
  }
}
